'use client';

import styles from './RaceTeamVideo.module.scss';
import Image from 'next/image';
import { useState } from 'react';
import VideoModal from './VideoModal';
import { RaceTeamVideoType } from '@/types/raceTeamVideo.types';

const RaceTeamVideo = ({ picture, videoUrl, videoType }: RaceTeamVideoType) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section className="container">
      <div className={styles.raceTeamVideo}>
        <Image
          src={picture}
          alt="Race Team"
          width={1220}
          height={563}
          className={styles.raceTeamVideoImage}
        />
        <Image
          src="/img/race-team/play.svg"
          alt="Play Video"
          width={170}
          height={170}
          className={styles.raceTeamPlayButton}
          onClick={() => setIsModalOpen(true)}
          style={{ cursor: 'pointer' }}
        />
      </div>
      <VideoModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        videoUrl={videoUrl}
        videoType={videoType}
      />
    </section>
  );
};

export default RaceTeamVideo;
